import type { RootState } from "../../types";

export const getToasts = (state: RootState) => state.toasts.list;
export const getAutoDeleteTime = (state: RootState) => state.toasts.autoDeleteTime;
